import { render } from "./Kelembagaan.vue?vue&type=template&id=b8896d1e"
import script from "./Kelembagaan.vue?vue&type=script&lang=js"
export * from "./Kelembagaan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__